import React from 'react';
import { range } from 'lodash';

import { Icon } from 'ui';
import COLORS from 'constants/colors';

const DUST_COUNT = 4;
const DEFAULT_DUST_COLOR = COLORS.YELLOW;

const ICONS = ['dust1', 'star-sparkle', 'dust1', 'circle-sparkle'];

const POSITIONS = [
  [-1, 2],
  [2, -1],
  [10, 8],
  [7, 11],
];

const getCSSPosition = i => {
  const [top, left] = POSITIONS[i].map(n => `${n * 10}%`);
  return { top, left };
};

const getStyle = (color, i) => ({
  fontSize: '14px',
  opacity: 1,
  transform: 'translate(-50%, -50%)',
  zIndex: 100,
  color: color || DEFAULT_DUST_COLOR,
  ...getCSSPosition(i),
});

const renderDustPiece = (i, color) => (
  <Icon
    className="pos-a"
    style={getStyle(color, i)}
    name={ICONS[i]}
    key={`dust_${i}`}
    stabilize={false}
  />
);

function CertificationDust({ color }) {
  return <>{range(DUST_COUNT).map(i => renderDustPiece(i, color))}</>;
}

export default CertificationDust;
